import { createStore, sample } from "effector"
import { createEffectorForm } from "@callcenter/effector-helpers"
import { $callcenterService, $userService } from "@callcenter/effector-services"
import { SpeechLanguageShortcut } from "@callcenter/shared-types"

import { DEFAULT_STATE } from "./transcript-translation.constants"

export const $availableSpeechLanguages = createStore<Array<{ key: SpeechLanguageShortcut; enabled: boolean }>>([])

export const { $formValue, $isFormChanged, handleChange, setFormValue } = createEffectorForm({
  defaultValue: DEFAULT_STATE,
  validationSchema: {}
})

/**
 * Set default form value
 */
sample({
  clock: $userService.$userSettings,
  source: {
    formValue: $formValue,
    permissions: $callcenterService.$permissions
  },
  filter: ({ permissions }) => permissions.has("transcript_translation"),
  fn: ({ formValue }, settings) => {
    const { translate_from, translate_to, transcript_translation_enabled } = settings

    const translateFromLanguages = translate_from
      .filter(({ enabled }) => enabled)
      .map(({ key }) => key)
      .sort((a, b) => a.localeCompare(b) - b.localeCompare(a))

    return {
      ...formValue,
      transcript_translation_enabled,
      translate_from_languages: translateFromLanguages,
      translate_to_language: translate_to
    }
  },
  target: setFormValue
})

sample({
  clock: $userService.$userSettings,
  fn: ({ translate_from }) => translate_from,
  target: $availableSpeechLanguages
})

sample({
  clock: handleChange,
  source: { availableSpeechLanguages: $availableSpeechLanguages, formValue: $formValue },
  filter: (_, { name, value }) => name === "transcript_translation_enabled" && Boolean(value),
  fn: ({ availableSpeechLanguages, formValue }) => ({
    ...formValue,
    translate_from_languages: availableSpeechLanguages
      .filter((lang) => lang.key !== SpeechLanguageShortcut.english)
      .map((lang) => lang.key),
    translate_to_language: SpeechLanguageShortcut.english
  }),
  target: $formValue
})
